'use client';

import React from 'react';
import { Briefcase, GraduationCap, Sparkles, Users } from 'lucide-react';
import { useTranslation } from '@/i18n/useTranslation';

const CARD_ICONS = [GraduationCap, Briefcase, Users, Sparkles];
const CARD_KEYS = [
  { title: 'landing_credible_id.card1_title', desc: 'landing_credible_id.card1_desc' },
  { title: 'landing_credible_id.card2_title', desc: 'landing_credible_id.card2_desc' },
  { title: 'landing_credible_id.card3_title', desc: 'landing_credible_id.card3_desc' },
  { title: 'landing_credible_id.card4_title', desc: 'landing_credible_id.card4_desc' },
];

export default function CredibleIdentitySection() {
  const { t } = useTranslation();
  return (
    <section className="bg-white py-20 sm:py-24">
      <div className="mx-auto max-w-screen-2xl px-6 lg:px-10 2xl:px-16">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <p className="mb-3 text-xs font-black uppercase tracking-[0.22em] text-trust-blue">
              {t('landing_credible_id.title' as any)}
            </p>
            <h2 className="text-3xl font-black tracking-tight text-[#002B7F] sm:text-4xl">
              {t('landing_credible_id.subtitle' as any)}
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-slate-600">
              {t('landing_credible_id.body' as any)}
            </p>
            <p className="mt-4 text-base leading-relaxed text-slate-600">
              {t('landing_credible_id.body2' as any)}
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {CARD_KEYS.map(({ title, desc }, i) => {
              const Icon = CARD_ICONS[i];
              return (
                <div
                  key={title}
                  className="rounded-2xl border border-slate-100 bg-slate-50/60 p-5"
                >
                  <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-trust-blue/10 text-trust-blue">
                    <Icon size={18} />
                  </div>
                  <h3 className="text-sm font-black text-slate-950">{t(title as any)}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-slate-600">{t(desc as any)}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
